import * as marietta from '../..';
import { SVGSprite } from '../flash/display';

export class ItemControllerMark {
    private target: marietta.webcad.item.MonicaObject;

    private allBox: marietta.webcad.control.parts.BoundingBox;

    private x: number;

    private y: number;

    private rotation: number;

    private tarLayer: marietta.webcad.layer.FloorShitaeLayer;

    public spt: SVGSprite;

    public emptySpt: SVGSprite;

    /**
     * コンストラクタ
     */
    constructor(_target: marietta.webcad.item.MonicaObject) {
      // ターゲット
      this.target = _target;
      this.initMe();
      if (this.target.itemInfo.lock) {
        this.hideToolTips();
      } else {
        this.showToolTips();
      }
    }

    /**
     * 初期化関数
     * viewObjの作成
     */
    initMe() {
        // 作成する階
        this.tarLayer = marietta.webcad.WebCADGlobal.layerGroup.getFloorLayer(this.target.itemInfo.floor) as marietta.webcad.layer.FloorShitaeLayer;
        // 形状の生成
        const viewObj: Element = document.createElementNS('http://www.w3.org/2000/svg', 'g');
        viewObj.id = 'controller';
        // 全体のボックス
        this.allBox = new marietta.webcad.control.parts.BoundingBox(viewObj);
        this.tarLayer.viewObj.appendChild(viewObj);
        this.spt = new SVGSprite(viewObj);
        // ターゲットに合わせてサイズ変更
        this.resizeToTarget();
      }

    /** Overwride */
    public resizeToTarget() {
        // 位置合わせ
        this.syncMeToTarget();
        // SVGSpriteのwidth/heightに書き換え
        const width: number = this.target.itemInfo.width;
        const height: number = this.target.itemInfo.height;
        // 全体Box
        this.allBox.resize({ width, height });
        this.allBox.move(0, 0);
        this.updateTransforms();
    }

    /**
     * ターゲットにシンクロする
     * ※アイテムのドラッグ時に呼び出される
     */
    syncMeToTarget() {
      this.x = this.target.itemInfo.x;
      this.y = this.target.itemInfo.y;
      this.rotation = this.target.itemInfo.rotation;
      this.updateTransforms();
    }

    /**
     * Translateのアップデート
     */
    updateTransforms() {
      this.spt.x = this.x;
      this.spt.y = this.y;
      this.spt.rotation = this.rotation;
      this.spt.update();
    }

    hideToolTips() {
      // Todo
    }

    showToolTips() {
      // Todo
    }
}